export default () => {
  const animItems = document.querySelectorAll(".animate-block");
  if (animItems.length > 0) {
    function animOnScroll() {
      if (document.documentElement.clientWidth > 1023) {
        for (let i = 0; i < animItems.length; i++) {
          const animItem = animItems[i];
          const animItemHeight = animItem.offsetHeight;
          const animItemOffset = offset(animItem).top;
          const animStart = 1.5;
          let animItemPoint = window.innerHeight - animItemHeight / animStart;
          if (animItemHeight > window.innerHeight) {
            animItemPoint = window.innerHeight - window.innerHeight / animStart;
          }
          if ((pageYOffset > animItemOffset - animItemPoint) && pageYOffset < (animItemOffset + animItemHeight)) {
            animItem.classList.add("animated");
          }
        }
      } else {
        for (let i = 0; i < animItems.length; i++) {
          animItems[i].classList.remove("animated");
        }
      }
    }

    function offset(el) {
      const rect = el.getBoundingClientRect();
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return {
        top: rect.top + scrollTop,
        left: rect.left + scrollLeft
      }
    }

    // setTimeout(function () {
    animOnScroll();
    // }, 500);

    window.addEventListener("scroll", animOnScroll);
    window.addEventListener("resize", animOnScroll);
  }

  const actions = document.querySelectorAll(".promo-pack__action");

  setInterval(function () {
    for (let i = 0; i < actions.length; i++) {
      actions[i].classList.add("shakeX");
    }
  }, 10000)

  setInterval(function () {
    for (let i = 0; i < actions.length; i++) {
      actions[i].classList.remove("shakeX");
    }
  }, 11000)
};
